/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjcInput from "@grapecity/wijmo.input"
import queryString from "query-string"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { showInfoToast } from "../../../components/CustomToast"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import {
  TSyoteiZikanListGetReq,
  TSyoteiZikanListGetRes,
  TSyoteiZikanPutReq,
} from "../../../service/master/SyoteiZikan/TSyoteiZikan"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"

import ConfirmModal from "../../../components/Modal/ConfirmModal"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import { TApiResponse } from "../../../service/TApiResponse"
import _ from "lodash"
import SyoteiZikanService from "../../../service/master/SyoteiZikan/syoteiZikanService"
import { RootState } from "../../../globalStore/rootreducer"

//#region [type]
export type T所定時間入力Item = TSyoteiZikanListGetRes &
  Partial<{
    カレンダー日数: number
    日付エラーフラグ: number
    行ID: symbol
  }>
//#endregion

/**
 * 所定時間マスタ
 * @returns
 */
const MasterSyoteiZikanList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  //TODO:ページ名称確定必須
  let gridId = "MasterSyoteiZikanList_GridId"

  //#region [method]

  interface ICalculatedFields {
    表示_年月: Date
    calculated所定時間: number
  }

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<T所定時間入力Item>) => {
    return new wjCore.CollectionView(data, {
      calculatedFields: {
        カレンダー日数: (i: T所定時間入力Item & ICalculatedFields) => {
          // 当月末+1で翌月月初を取得
          const monthEnd = dayjs(i.年月)
            .endOf("month")
            .add(1, "D")
            .format("YYYY/MM/DD")

          // 当月の月初～翌月月初の差分により日数算出
          return dayjs(monthEnd).diff(i.年月, "day")
        },
        日付エラーフラグ: (i: T所定時間入力Item & ICalculatedFields) => {
          const カレンダー日数 = i.カレンダー日数 ?? 0
          if (カレンダー日数 < i.営業日数) {
            return 1
          } else {
            return 0
          }
        },
        // calculated所定時間: (i: T所定時間入力Item & ICalculatedFields) => {
        //   //   const i営業日数 = i.営業日数 ?? 0
        //   //   return i営業日数 * 8
        //   const i営業日数 = new Decimal(i.営業日数 ?? 0)
        //   const 日労働時間 = new Decimal(8)
        //   return i営業日数.times(日労働時間).toNumber()
        // },
      },
    })
  }

  const beforeSearch = () => {
    // TODO:バリデーションチェック
    if (!isValidationCheckBeforeSearch()) return
    search()
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TSyoteiZikanListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    disPatch(clearAlert()) // アラートを非表示に
    setIsSubmitButton(false)

    // 削除用リストを初期化
    let clearList: TSyoteiZikanListGetRes[] = []
    setGridDataDeleteList(clearList)

    let currentSearchCondition: TSyoteiZikanListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new SyoteiZikanService().getList(currentSearchCondition)

      // 検索結果が存在しない場合、空データをCollectionViewに設定する
      if (res.data.length < 1) {
        // TODO:１年分の空データでリスト作成
        const 月数 = 12
        const baseItemList: T所定時間入力Item[] = []

        // １年分のリスト作成
        for (let i = 0; i < 月数; i++) {
          // 検索条件の年月日から１年分のデータフォーマットを作成し格納していく。
          // ※ 指定年/01/01からスタート
          const i年月 = dayjs()
            .year(currentSearchCondition.年!)
            .startOf("year")
            .add(i, "M")
            .format("YYYY/MM/DD")

          const items: T所定時間入力Item = {
            所定時間ID: undefined,
            年月: i年月,
            営業日数: 0,
            更新日時: "",
            削除フラグ: 0,
          }
          baseItemList.push(items)
        }
        // ベースデータとして、検索月の１年分のダミーデータをセットする
        setGridData({ data: createCollectionView(baseItemList) })

        // 検索結果が存在する場合の処理
      } else {
        // 削除用リストを作成する
        let copyListSyoteiZikan: TSyoteiZikanListGetRes[] = []
        res.data.forEach((d) => {
          // DeepCopy
          copyListSyoteiZikan.push(_.cloneDeep(d))
        })
        setGridDataDeleteList(copyListSyoteiZikan)

        // Grid表示用
        let gridItem: TSyoteiZikanListGetRes[] = []
        res.data.forEach((d) => {
          // DeepCopy
          gridItem.push(_.cloneDeep(d))
        })
        setGridData({ data: createCollectionView(gridItem) })
      }

      setAccordionController(false)
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
      setIsSubmitButton(true)
      flexGrid?.refresh()
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TSyoteiZikanListGetReq = queryString.parse(location.search)
    set年(query.年!)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TSyoteiZikanListGetReq => {
    return {
      検索年: dayjs().year(年!).startOf("year").format("YYYY/MM/DD"),
      年,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TSyoteiZikanListGetReq
  ) => {
    return {
      年: searchCondition.年,
    }
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjcGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      let errorFlg = false
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        const dataItem = e.getRow().dataItem as T所定時間入力Item

        if (dataItem.日付エラーフラグ === 1) {
          wjCore.toggleClass(
            e.cell,
            "data-warning",
            dataItem.日付エラーフラグ === 1
          )
          errorFlg = true
        }
      }

      if (errorFlg && Form外エラーメッセージList.length < 1) {
        Form外エラーメッセージList.push(
          "営業日数が月の合計を超過しているレコードが存在します。"
        )
        setHasSearched(true)
      }
    }
  }

  const beforeSubmit = () => {
    // TODO:バリデーションチェック
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    // 対象月の日数を営業日数が超過しているかチェック
    gridData.data.items.forEach((d: T所定時間入力Item) => {
      if (d.日付エラーフラグ === 1) {
        Form外エラーメッセージList.push(
          "営業日数が月の合計を超過しているレコードが存在します。"
        )
        setHasSearched(true)
      }
    })
    setIsConfirmModalShow(true)
  }

  // TODO:PUTのみ？
  const submit = async () => {
    try {
      // DB更新用リスト
      let dataList: Array<TSyoteiZikanPutReq> = []

      //   入力Gridを全て新規データとしてセットする
      gridData.data.items.forEach(
        (d: T所定時間入力Item & ICalculatedFields) => {
          // 新規登録する為、IDと更新日時はundefined
          // 削除フラグは0に設定する
          let data: TSyoteiZikanPutReq = {
            所定時間ID: undefined,
            年月: d.年月,
            営業日数: d.営業日数,
            所定時間: d.所定時間 ?? 0,
            更新日時: undefined,
            削除フラグ: 0,
          }
          dataList.push(data)
        }
      )

      // 既存データを削除リストとしてセット
      gridDataDeleteList?.forEach((d: T所定時間入力Item) => {
        // 削除フラグを1にして追加
        let data: TSyoteiZikanPutReq = {
          所定時間ID: d.所定時間ID,
          年月: d.年月,
          営業日数: d.営業日数,
          所定時間: d.所定時間 ?? 0,
          更新日時: d.更新日時,
          削除フラグ: 1,
        }
        dataList.push(data)
      })

      const service = new SyoteiZikanService()

      let res: TApiResponse<boolean>

      // 更新対象のリストをserviceに渡す。
      res = await service.put(dataList)

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(`所定時間マスタの更新が完了しました。`)
      }
      // 遷移してきた際のクエリパラメータで検索条件を生成
      const querySearchCondition = queryParse()

      // リストア中フラグON
      setIsRestoreSearching(true)

      // 再検索
      // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
      search(querySearchCondition).finally(() => {
        disPatch(画面ロック解除())
      })
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 桁数を返す関数
   * @param num
   * @returns
   */
  const numDigits = (num: number) => {
    return num.toString().length
  }

  /**
   * 検索時のチェック
   */
  const isValidationCheckBeforeSearch = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // nullチェック
    if (年 == null) {
      messages.push(`年 を入力してください。`)
      hasError = true
    }
    // NaNチェック
    else if (isNaN(年)) {
      messages.push(`数値 を入力してください。`)
      hasError = true
    } else {
      const num = numDigits(年)
      if (4 !== num) {
        messages.push(`年数は YYYY の形式で入力してください。`)
        hasError = true
      }
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }
    return !hasError
  }
  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [pageSize, setPageSize] = useState<number>(10)

  // 祝日グリッド用
  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([]),
  })

  // 削除アイテムリスト
  const [gridDataDeleteList, setGridDataDeleteList] =
    useState<TSyoteiZikanListGetRes[]>()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中
  const [isSubmitButton, setIsSubmitButton] = useState(false) // 検索後

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const disPatch: AppDispatch = useDispatch()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  // state
  const [年, set年] = useState<number>(parseInt(dayjs(eigyobi).format("YYYY")))

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `所定時間マスタ`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
    // set年(parseInt(dayjs(eigyobi).format("YYYY")))
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        // Ref更新などをValidationの中で行ってるため、検索前に経由させる。
        search(querySearchCondition).finally(() => {
          disPatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        disPatch(画面ロック解除())
        if (isValidationCheckBeforeSearch()) {
          search()
        }
      }
    }
  }, [gridInitialized])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">所定時間マスタ</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-30rem">
            {/* CardHeaderをアコーディオン化 ⇒ 入力対象キーでもあるため、一旦制御無し */}
            <Card.Header
              // onClick={() => setAccordionController(!accordionController)}
              onClick={() => setAccordionController(true)}
              aria-controls="collapse-search-card-body"
              aria-expanded={true}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={true}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    {/* 固定項目 */}
                    <Row>
                      <Col>
                        <div className="w-4rem">
                          <NumberInput
                            autoFocus
                            id="年"
                            name="年"
                            min={1900}
                            max={9999}
                            step={1}
                            required
                            value={年}
                            setValue={(v) => {
                              set年(v)
                            }}
                            placeholder="年"></NumberInput>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            beforeSearch()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card className="w-60rem h-100">
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>

              {/* 休日区分ごとにGridを分割 */}
              <div className="d-flex">
                <div className="overflow-auto">
                  <FlexGridOuter
                    flexGrid={flexGrid}
                    setFlexGrid={setFlexGrid}
                    gridConstantProperties={
                      CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT
                    }
                    gridData={gridData}
                    setGridData={setGridData}
                    pageNumber={0}
                    gridId={`${gridId}_1`}
                    isRestoreSearching={isRestoreSearching}
                    setIsRestoreSearching={setIsRestoreSearching}
                    gridInitialized={gridInitialized}
                    setGridInitialized={setGridInitialized}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    gridInitializedHandler={gridInitializedHandler}
                    isShowGridRowPickupButton={false}
                    isShowGridFooter={false}
                    gridProperties={{
                      allowAddNew: false,
                      allowDelete: false,
                      allowSorting: wjcGrid.AllowSorting.None,
                    }}>
                    <wjrGrid.FlexGridColumn
                      binding="年月"
                      width={70}
                      isReadOnly
                      cssClass="read-only-cell"
                      header="月">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<
                            T所定時間入力Item & ICalculatedFields
                          >
                        ) => {
                          return (
                            <>
                              <span>
                                {dayjs(context.item.年月).format("MM月")}
                              </span>
                            </>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>

                    <wjrGrid.FlexGridColumn
                      binding="営業日数"
                      width={120}
                      header="営業日数"
                      dataType={wjCore.DataType.Number}
                      format={"N1"}
                      editor={
                        new wjcInput.InputNumber(
                          document.createElement("div"),
                          {
                            format: "N1",
                            min: 0,
                            isRequired: false,
                          }
                        )
                      }></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="所定時間"
                      width={120}
                      dataType={wjCore.DataType.Number}
                      format={"N1"}
                      // isReadOnly
                      // cssClass="read-only-cell"

                      editor={
                        new wjcInput.InputNumber(
                          document.createElement("div"),
                          {
                            format: "N1",
                            min: 0,
                            isRequired: false,
                          }
                        )
                      }
                      header="所定時間"></wjrGrid.FlexGridColumn>
                  </FlexGridOuter>
                </div>
              </div>
              <Row>
                <Col>
                  <div>
                    <Button
                      type="button"
                      variant={isSubmitButton ? "waiting" : "secondary"}
                      disabled={!isSubmitButton}
                      onClick={() => {
                        beforeSubmit()
                      }}>
                      登録
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </Container>
  )
}

export default MasterSyoteiZikanList
